import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { RootfiSettingsHistoryResponse } from './types';

export function useSettingsHistory(
  rootfiCompanyId: number | null,
  corporationId: number
) {
  const { data, error, isLoading } = useSWR<RootfiSettingsHistoryResponse>(
    rootfiCompanyId
      ? `rootfi/${rootfiCompanyId}/settings/history?corporationId=${corporationId}`
      : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    history: data?.history ?? [],
    error,
    isLoading,
  };
}
